module.exports = __webpack_public_path__ + "media/base/arrow-down-321bf94f.svg";